import React from "react";
import styles from "./LatestPosts.module.css";
import ico from "./graduation.png";
// <li className={styles.item}>{post.title}</li>

const Postitem = (props: {
  key: string;
  title: string;
  date: string;
  image: string;
  url: string;
}) => (
  <li className={styles.item}>
    <div>
      <img src={props.image} alt="icon" className={styles.circular_image} />
    </div>
    <div style={{ marginLeft: 10, marginTop: 5 }}>
      <div className={styles.dateStyle}>{props.date}</div>
      <div className={styles.titleStyle}>
        <a href={props.url} target="_blnank" className={styles.titleStyle}>
          <div className={styles.titleStyle}>{props.title}</div>
        </a>
      </div>
    </div>
  </li>
);

export default Postitem;
